import React from 'react';

import {BulkActionResult} from 'src/components/bulk-tool';

import {RemoveAttendeesResultModal} from './remove-attendees.result.modal';
import {
    clearResult,
    selectRemoveAttendeesShown,
    selectRemoveAttendeesTask,
    selectRemoveAttendeesUuid,
} from './remove-attendees.slice';

export const RemoveAttendeesResult = () => (
    <BulkActionResult
        actionIdSelector={selectRemoveAttendeesUuid}
        actionTaskSelector={selectRemoveAttendeesTask}
        actionShownSelector={selectRemoveAttendeesShown}
        clearResult={clearResult}>
        {({id, onClose}) => (
            <RemoveAttendeesResultModal id={id} onClose={onClose}/>
        )}
    </BulkActionResult>
);
